import React from 'react';
import './UserAvatarStack.less';
import { Avatar } from 'app/components/Avatar';
import { AvatarBase } from 'app/components/Avatar/components';

interface Props {
  users: { firstName: string; lastName?: string }[];
  displayNameCount?: number;
}

export default function UserAvatarStack({
  users,
  displayNameCount = 6,
}: Props) {
  const displayedNames = users.slice(0, displayNameCount);
  const remainingNamesCount = users.length - displayedNames.length;

  return (
    <div className="user-avatar-stack">
      {displayedNames.map((user, index) => (
        <Avatar
          key={index}
          className="user-avatar-stack__avatar"
          email=""
          firstName={user.firstName}
          lastName={user.lastName}
        />
      ))}

      {remainingNamesCount > 0 && (
        <AvatarBase
          className="user-avatar-stack__avatar"
          text={`+${remainingNamesCount}`}
        />
      )}
    </div>
  );
}
